import {HitModule} from './ModuleHit';

class UserCompany implements MyUserCompany {
  constructor(
    public usernameEmail: string | null,
    public password: string | null,
    public firstName: string | null,
    public lastName: string | null,
    public countryCode: string | null,
    public vatNumber: string | null,
    public userSystemLanguage: string | null,
    public designationLegal: string | null,
    public street: string | null,
    public houseNumber: string | null,
    public boxNumber: string | null,
    public postCode: string | null,
    public city: string | null,
    public billingEmail: string | null,
    public phone: string | null,
    public mobile: string | null,
    public rightsAccepted: boolean,
    public dateRequest: Date,
    public checkVatNumberBeforeAddAccount: boolean,
    public confirmPassword: string | null,
    public activity: string | null,
    public referralCode: string | null
  ) {}
}

export interface MyUserCompany {
  usernameEmail: string | null;
  password: string | null;
  confirmPassword: string | null;
  firstName: string | null;
  lastName: string | null;
  vatNumber: string | null;
  countryCode: string | null;
  designationLegal: string | null;
  street: string | null;
  houseNumber: string | null;
  boxNumber: string | null;
  postCode: string | null;
  city: string | null;
  billingEmail: string | null;
  phone: string | null;
  mobile: string | null;
  rightsAccepted: boolean;
  dateRequest: Date;
  checkVatNumberBeforeAddAccount: boolean;
  userSystemLanguage: string | null;
  activity: string | null;
  referralCode: string | null;
  modules?: HitModule[];
}

export function getFakeAccount(): MyUserCompany {
  const varOut: MyUserCompany = fakeAccounts[0];
  return varOut;
}

const fakeAccounts: UserCompany[] = [
  new UserCompany(
    'm.maes@ficos.com',
    'password',
    'Maxime',
    'Maes',
    'LU',
    'LU35205156',
    'fr',
    'Ficos SARL (createtest)',
    'Place Nicolas Adames',
    '1',
    '',
    'L-9912',
    'Troisvierges',
    'm.maes@ficos.com',
    '+35220882023',
    null,
    true,
    new Date(),
    true,
    'johnpassword123',
    'activity',
    'abcdef'
  ),
];
